import { createMuiTheme } from '@material-ui/core/styles';
//import createPalette from '@material-ui/core/styles/palette';

import blue from '@material-ui/core/colors/blue';
//const stlBlue = '#137EC2';
const stlBlue = '#1289d4';
const stlOrange = '#E9791E';

export const theme = createMuiTheme({
	overrides: {
		MuiButton: {
			root: {
				// Name of the rule
				borderRadius: 100,
			},
		},
	},
	typography: {
		useNextVariants: true,
	},
	zIndex: {
		modal: 800, // change from 1300 to 800
		appBar: 700, // change from 1100 to 800
	},
	palette: {
		primary: {
			// light: will be calculated from palette.primary.main,
			main: stlBlue,
			// dark: will be calculated from palette.primary.main,
			// contrastText: will be calculated to contrast with palette.primary.main
		},
		secondary: {
			main: stlOrange,
			// dark: will be calculated from palette.secondary.main,
			//contrastText: '#ffcc00',
		},

		//primary: stlBlue,
	},
});

export const getGlobalClasses = (theme) => {
	return {
		globalMainHeadline: {
			textTransform: 'uppercase',
			color: '#666',
			fontSize: 20,
			fontWeight: 400,
			margin: '2px 0px 5px 0px',
			[theme.breakpoints.up('sm')]: {
				fontWeight: 300,
				color: '#999',
				fontSize: 30,
				margin: '10px 0px 10px 0px',
			},
			[theme.breakpoints.up('md')]: {
				fontSize: 40,
				margin: '10px 0px 10px 0px',
			},

			//paddingBottom : 20,
			//fontFamily: 'Roboto-Thin',
			//borderBottom: '1px solid #eee',
			letterSpacing: 1,
		},
		globalMainPaper: {
			width: '100%',
			//overflowX : 'auto',
			//minHeight : 500,
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: 10,
			[theme.breakpoints.up('sm')]: {
				padding: '20px 20px 40px 20px',
			},
			borderRadius: 0,
			marginBottom: 20,
		},
		globalFetching: {
			fontStyle: 'italic',
			padding: '10px 0px',
			color: '#777',
		},
		globalPleasePick: {
			padding: 20,
			color: '#444',
			background: '#f7f7f7',
			border: '1px solid #ddd',
			borderRadius: 2,
		},
	};
};

export const getGlobalMobileClasses = (theme) => {
	return {
		globalContent: {
			position: 'fixed',
			top: '12vw',
			bottom: '20vw',
			left: 0,
			right: 0,
			overflow: 'scroll',
			paddingLeft: '1.25vw',
			paddingRight: '1.25vw',
			paddingTop: '1.25vw',
			//padding: 20,
			//boxSizing: 'border-box',
			//height: '100%',
		},
	};
};

export const darkTheme = createMuiTheme({
	typography: {
		useNextVariants: true,
	},
	palette: {
		type: 'dark',
		primary: blue,
	},
});
